<template>
  <div class="app-container">
    <basic-container>
      <div class="operation">
        <el-button @click="cancel" v-if="goBack" size="medium">取消</el-button>
        <el-button size="medium" type="primary" v-if="!showSubject" @click="onSubmit()">保存</el-button>
        <div v-if="isShowEditSubmit">
          <el-button @click="cancelEdit" size="medium">取消</el-button>
          <el-button size="medium" type="primary" @click="onEditSubmit()">保存</el-button>
        </div>
      </div>
      <el-form ref="subjectLibForm" class="sizeForm" :model="subjectLibForm" label-width="100px" size="medium" :rules="rules">
        <el-row>
          <el-col :span="18">
            <el-form-item label="题库名称" prop="name">
              <el-input v-model="subjectLibForm.name" :disabled='showSubject && !isShowEditSubmit' placeholder="请输入题库名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="text"
              v-if="isEdit"
              icon="el-icon-edit"
              size="mini"
              style="margin: 10px 0 0 10px;"
              @click="handleEdit()"></el-button>
          </el-col>
        </el-row>
      </el-form>
    </basic-container>
    <subject-list v-if="showSubject" :libId="id"/>
  </div>
</template>
<script>
import subjectList from './subject-list.vue'
import { createSubjectLib, editSubjectLib, getSubjectLibDetail } from '@/api/app/subject-lib'

export default {
  components: {
    subjectList
  },
  data() {
    return {
      subjectLibForm: {
        name: '',
      },
      id: '',
      isEdit: false,
      showSubject: false,
      isShowEditSubmit: false,
      goBack: true,
      tagList: [],
      isUploadSuccess: [],
      rules: {
        name: [
          { type: 'string', required: true, message: '请输入题库名称', trigger: 'blur' },
          { max: 256, message: '不超过256个', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
  },
  mounted() {
    this.id = this.$route.params.id;
    if(this.id) {
      this.isEdit = true;
      this.getDetail();
    }
  },
  methods: {
    cancel () {
      this.$router.$avueRouter.closeTag()
      this.$router.go(-1)
    },
    onSubmit() {
      const params = Object.assign({}, this.subjectLibForm);
      this.$refs.subjectLibForm.validate((valid) => {
        if (valid) {
          createSubjectLib(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '创建成功',
                type: 'success'
              })
              this.id = res.data.data;
              this.isEdit = true;
              this.showSubject = true;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
          })
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    },
    getDetail() {
      getSubjectLibDetail(this.id).then(res => {
        this.subjectLibForm = res.data.data;
        this.showSubject = true;
      }).catch(error => {
        this.$message({
          message: '获取题库详情失败',
          type: 'error'
        })
      })
    },
    handleEdit() {
      this.isShowEditSubmit = true;
      this.goBack = false;
    },
    cancelEdit() {
      this.isShowEditSubmit = false;
      this.goBack = true;
    },
    onEditSubmit() {
      const params = Object.assign({}, this.subjectLibForm);
      if(!params.id) {
        params.id = this.id;
      } 
      this.$refs.subjectLibForm.validate((valid) => {
        if (valid) {
          editSubjectLib(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '编辑成功',
                type: 'success'
              })
              this.cancelEdit();
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
          })
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
  .operation {
    text-align: right;
  }
  .sizeForm{
    width: 650px;
  }
  .vote-option-row{
    margin-bottom: 15px;
    .image-url-options{
      width: 148px;
      height: 148px;
      border-radius: 6px;
      margin-right: 8px;
      float: left;
      object-fit: cover;
    }
  }
  .permission{
    margin-top: 10px;
  }
  .option-desc{
    margin: 20px 0 0 0;
  }
  .permission-group{
    margin-bottom: 20px;
  }
  .start-time-col, .end-time-col{
    padding: 0 !important;
    margin: 0 !important;
  }
  .img-box{
    margin-top: 20px;
  }
</style>
